import type { OrderDetailPrepaymentSettlementPayment } from "@/api/user/types/member"

export interface PrepaymentSettlementDisplayRow {
  key: string
  label: string
  amount: number
  payType?: number | null
  sourcePaymentTypeId?: number | null
}

function normalizeAmount(value: unknown) {
  const amount = Number(value)
  return Number.isFinite(amount) && amount > 0 ? Math.round(amount) : 0
}

function normalizeName(value: unknown) {
  return String(value ?? "").trim()
}

export function buildPrepaymentSettlementDisplayRows(
  breakdown?: OrderDetailPrepaymentSettlementPayment[] | null,
): PrepaymentSettlementDisplayRow[] {
  return (breakdown ?? []).flatMap((item, index) => {
    const amount = normalizeAmount(item.amount)
    if (amount === 0) return []

    const sourceName = normalizeName(item.sourcePaymentTypeName) || "原支付渠道"
    return [{
      key: `prepayment-settlement-${item.sourcePaymentType ?? "unknown"}-${item.sourcePaymentTypeId ?? "default"}-${index}`,
      label: `预付款抵扣（${sourceName}）`,
      amount,
      payType: item.sourcePaymentType,
      sourcePaymentTypeId: item.sourcePaymentTypeId,
    }]
  })
}
